import { render } from "./UpdateRewardSidebar.vue?vue&type=template&id=de16e2d8&scoped=true"
import script from "./UpdateRewardSidebar.vue?vue&type=script&lang=js"
export * from "./UpdateRewardSidebar.vue?vue&type=script&lang=js"

import "./UpdateRewardSidebar.vue?vue&type=style&index=0&id=de16e2d8&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de16e2d8"]])

export default __exports__